module.exports = __webpack_public_path__ + "img/banner.c387622b.jpg";